<template>
  <div class="configure-vehicle-component">
    <div class="container">
      <div class="row">
        <div class="col-12 p-0">
          <h1>{{ currentProduct.configure_heading }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-8 body">
          <p class="mb-4">{{ currentProduct.configure_description }}</p>
          <div>
            <div class="row">
              <div class="col-12">
                <h3 v-if="shortlist">{{ shortlist.manufacturerName }} {{ shortlist.modelName }}</h3>
                <h4 v-if="shortlist">{{ shortlist.derivativeName }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr/>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <h5>Required options</h5>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-4">
                    <div class="custom-multiselect mb-2">
                      <label for="trim">Colour</label>
                      <multiselect
                        id="colour"
                        v-model="vueColour"
                        placeholder=""
                        label="description"
                        track-by="description"
                        option="value"
                        :multiple="false"
                        :options="colourOptions"
                        @update:model-value="changeFactoryOption"
                      >
                      </multiselect>
                    </div>
                  </div>

                  <div class="col-12 mb-4">
                    <div class="custom-multiselect mb-2">
                      <label for="trim">Trim</label>
                      <multiselect
                        id="trim"
                        v-model="vueTrim"
                        placeholder=""
                        label="description"
                        track-by="description"
                        option="value"
                        :multiple="false"
                        :options="trimOptions"
                        @update:model-value="changeFactoryOption"
                      >
                      </multiselect>
                    </div>
                  </div>
                </div>


                <div class="row mb-4">
                  <div class="col-4" v-if="shortlist">
                    <template v-if="isSalSac">
                      <div class="custom-multiselect mb-2">
                        <div class="input-group">
                          <label for="term">Term</label>
                          <multiselect
                            id="term"
                            v-model="term"
                            :multiple="false"
                            :options="supportedTerms"
                            @select="switchTerm"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="input mb-2">
                        <div class="input-group">
                          <label for="term" class="no-transition">Term</label>
                          <input disabled id="term" v-model="term">
                        </div>
                      </div>
                    </template>
                  </div>

                  <div class="col-4" v-if="shortlist">
                    <template v-if="isSalSac">
                      <div class="custom-multiselect mb-2">
                        <div class="input-group">
                          <label for="mileage">Annual Mileage</label>
                          <multiselect
                            id="mileage"
                            v-model="mileage"
                            :multiple="false"
                            :options="supportedMileages"
                            @select="switchMileage"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="input mb-2">
                        <div class="input-group">
                          <label for="mileage" class="no-transition">Annual Mileage</label>
                          <input disabled id="mileage" v-model="mileage">
                        </div>
                      </div>
                    </template>
                  </div>

                  <!--                                        <div class="col-4">
                                                              <mpg-slider :default-mpg="30"
                                                                          :quote="{ quote: { quoteID: shortlist.quoteID } }"/>
                                                          </div>-->
                </div>


                <div class="row">
                  <div class="col-12">
                    <h5>Specification &amp; Optional Extras</h5>
                  </div>
                </div>
                <div class="tabs">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex flex-row">
                        <button :class="{ 'active' : tab === 'optional-extras'}"
                          @click="tabs('optional-extras')">Optional extras
                        </button>
                        <button :class="{ 'active' : tab === 'standard-specification' }"
                          @click="tabs('standard-specification')">Standard
                          specification
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="tab === 'optional-extras'">
                  <div class="row">
                    <div class="col-12">
                      <div class="accordion" id="optional-extras">
                        <div class="card" v-for="group in derivativeFactoryOptions"
                          :key="`optional-extras-heading-${group.slug}`">
                          <div class="card-header"
                            :id="`optional-extra-heading-${group.slug}`">
                            <button class="btn btn-link" type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="`#collapse-optional-extras-${group.slug}`"
                              aria-expanded="false"
                              :aria-controls="`collapse-optional-extras-${group.slug}`">
                              {{ group.name }} ({{ group.subgroup_count }})
                            </button>
                          </div>
                          <div :id="`collapse-optional-extras-${group.slug}`"
                            class="collapse"
                            :aria-labelledby="`optional-extra-heading-${group.slug}`"
                            data-bs-parent="#optional-extras">
                            <div class="card-body">
                              <ul>
                                <template v-for="subgroup in group.items">
                                  <li class="card-subheader">
                                    {{subgroup.name}}
                                  </li>
                                  <li v-for="(item, key) in subgroup.items">
                                    <div
                                      class="d-flex flex-row justify-content-between">
                                      <div>
                                        <div class="checkbox">
                                          <input type="checkbox"
                                            :id="`optional-extras-${subgroup.slug}-${key}`"
                                            :name="`optional-extras-${subgroup.slug}-${key}`"
                                            @click="toggleFactoryOption(shortlist.quote.quoteGUID, item.factoryOptionID, item.selected ? 'removed' : 'added')"
                                            :checked="item.selected"/>
                                          <label
                                            :for="`optional-extras-${subgroup.slug}-${key}`">
                                            {{item.description}}
                                          </label>
                                        </div>
                                      </div>
                                      <div>
                                        <span>+£{{ item.basicPrice + item.vat }}</span>
                                      </div>
                                    </div>
                                  </li>
                                </template>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row">
                    <div class="col-12">
                      <div class="accordion" id="standard-specification">
                        <div class="card"
                          v-for="(group, index) in shortlist.derivative.standardEquipmentItems"
                          :key="`standard-specification-heading-${group.slug}`">
                          <div class="card-header"
                            :id="`optional-extra-heading-${group.slug}`">
                            <button class="btn btn-link" type="button"
                              data-bs-toggle="collapse"
                              :data-bs-target="`#collapse-standard-specification-${group.slug}`"
                              aria-expanded="false"
                              :aria-controls="`collapse-standard-specification-${group.slug}`">
                              {{ group.name }} ({{ group.count }})
                            </button>
                          </div>
                          <div :id="`collapse-standard-specification-${group.slug}`"
                            class="collapse"
                            :aria-labelledby="`optional-extra-heading-${group.slug}`"
                            data-bs-parent="#standard-specification">
                            <div class="card-body">
                              <ul>
                                <li v-for="(item) in group.items">
                                  <div
                                    class="d-flex flex-row justify-content-between">
                                    <div>
                                      <span>
                                          {{ item.standardEquipmentName }}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-4 sidebar">
          <!-- Actions -->
          <div class="row">
            <div class="col-12">
              <div class="actions d-flex flex-row">
                <button class="delete" @click="deleteQuote"><span class="icon-cross"></span>
                  <span>Delete this Quote</span>
                </button>
                <button class="back" @click="backToShortlist"><span
                  class="icon-arrow-right-1 icon-flip-horizontal"></span>
                  <span>Back to Comparison</span></button>
              </div>
            </div>
          </div>
          <!-- Gallery -->
          <div class="row">
            <div class="col-12">
              <div class="gallery">
                <div class="row">
                  <div class="col-12 text-start">
                    <h3>Gallery</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <!-- Main -->
                    <vehicle-image v-if="shortlist" :derivative="shortlist.quote.derivative" :showMain="true" :showThumbs="true" :enableGallery="true" :style-overrides="{width:'100%'}"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <p>*All pictures shown are for illustration purpose only. Actual vehicle may
                      vary due to specification.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="shortlist" class="row">
            <div class="col-12">
              <!-- Additions -->
              <div class="additions">
                <div class="row">
                  <div class="col-12">
                    <h3>Your current additions</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="ul">
                      <div v-for="(group, key) in quoteFactoryOptions">
                        <h4>{{ key }}</h4>
                        <div v-for="item in group" class="li d-flex flex-column">
                          <template v-if="!item.isDefault">
                            <span>{{
                                item.description
                              }}</span><span>+£{{ Math.floor(((item.price * 1.2) * 100) / 100).toFixed(2) }}</span>
                            <button
                              @click="toggleFactoryOption(shortlist.quote.quoteGUID, item.factoryOptionID, 'removed')">
                              <i class="icon-cross"></i></button>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Quote -->
              <div class="reference" style="background-color:#2c3136;">
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex flex-column">
                      <label for="quote-name">Add a custom name to this quote for your
                        reference</label>
                      <input type="text" id="quote-name" name="quote-name"
                        placeholder="Quote name"
                        v-model="shortlist.quote.definition.quoteName"/>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <ul>
                      <li v-if="hasRatebook">
                        <!-- Net cost cant update live as no tax calcs on a working quote. Hide for now, as per Martyn/Nick 16/6/25 on trello -->
<!--                        <span style="display:flex;justify-content:space-between;align-items: center;margin-bottom:20px;">
                          <span style="font-size:14px;">Estimated NET Monthly Cost</span>
                          <span style="font-size:30px;font-weight:600;">£{{ RatebookHelper.netCost(this.shortlist.quote.taxCalculations, this.shortlist.quote.definition.plan.term) }}</span>
                        </span>
                        <span style="font-size:11px;line-height:11px;">Please note the cost of options do not necessarily match up to your budget, and this
                        differs by vehicle</span>-->
                      </li>
                      <template v-else>
                        <li class="d-flex flex-row justify-content-between" v-if="showBik">
                            <span>
                              Monthly BIK ({{getBikRate(shortlist) }}%)
                              <br/>
                              (estimated)
                            </span>
                          <span>£{{getBikValue(shortlist)}}</span>
                        </li>
                        <template v-else-if="isSalSac">
                          <li class="d-flex flex-row justify-content-between">
                            <!-- <span>Vehicle Net Monthly Cost is calculated after saving configuration.</span> -->
                            <span>The salary sacrifice illustration is calculated after saving the configuration.</span>
                          </li>
                        </template>
                        <template v-else-if="isBch && costConfiguration">
                          <li v-if="costConfiguration.showRental === 'totaleffective'" class="d-flex flex-row justify-content-between">
                            <span>Vehicle Rental</span>
                            <span>£{{ shortlist?.quote?.details?.lifeCosts?.totalEffectiveRental }}</span>
                          </li>
                          <li v-if="costConfiguration.showRental === 'rentalexvat'" class="d-flex flex-row justify-content-between">
                              <span>Vehicle Rental</span>
                              <span>£{{ shortlist?.quote?.details?.pricing?.totalExVAT }}</span>
                          </li>
                        </template>
                        <template v-else>
                          <li class="d-flex flex-row justify-content-between">
                            <span>{{ costTotalLabel }}</span><span>£{{ totalNetCost }}</span>
                          </li>
                        </template>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-text v-if="footerText" :footerText="footerText"/>
    <text-modal-small-component v-if="showModal === true" @close="closeModal('')">
      <template v-slot:header>

      </template>
      <template v-slot:body>
        <p><b>Please ensure you select an interior seat trim and interior embellishment trim
          (if applicable) within the Trim section of the optional extras</b></p>
      </template>
    </text-modal-small-component>
  </div>
</template>


<script>
import {EventBus} from '@/event-bus.js';
import Slick from 'vue-slick';
import Multiselect from 'vue-multiselect'
import MpgSlider from "./car-comparison/mpg-slider";
import FooterText from "./footer/footer-text";
import VehicleCosts from '../helpers/vehicle-costs'
import VehicleImage from "@/components/vehicle-details/vehicle-image.vue";
import RatebookHelper from "@/helpers/ratebook";
import {useRoute} from "vue-router";

export default {

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.get(to.params.shortListId, to.params.quoteId);
      vm.quoteId = to.params.quoteId;
      vm.shortlistId = to.params.shortListId;

    })
  },

  props: [
    'adminPortalData',
    'adminPortalPrimaryProduct',
    'save-configuration',
    'session'
  ],

  data: () => {
    return {
      modalShow: true,
      quoteId: null,
      shortlistId: null,
      shortlist: null,
      derivative: null,
      colourOptions: [],
      vueColour: [],
      trimOptions: [],
      vueTrim: [],
      quoteFactoryOptions: [],
      derivativeFactoryOptions: [],

      supportedTerms: [24, 36, 48],
      term: null,

      supportedMileages: [
        8000,
        10000,
        12000,
        14000,
        15000,
        16000,
        18000,
        20000,
        22000,
        24000,
        25000,
        26000,
        28000,
        30000,
        32000,
        34000,
        35000,
        36000,
        38000,
        40000,
      ],
      mileage: 0,

      tab: 'optional-extras',

      slickMain: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
        speed: 750,
        asNavFor: '.slickThumbs',
        arrows: false,
      },

      slickThumbs: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
        speed: 750,
        asNavFor: '.slickMain',
        focusOnSelect: true,
        arrows: false
      },

      quoteName: null,
      currentConfiguredQuote: {
        color: null,
        trim: null,
        options: []
      },

    }
  },

  setup() {
    const route = useRoute();
    return { route }
  },

  created() {
    this.getVehicleBikByRate = VehicleCosts.getVehicleBikByRate;
  },

  computed: {
    hasRatebook() {
      return this.RatebookHelper.isRatebookEnabledGrade(this.shortlist.quote.details.driverGradeName);
    },
    RatebookHelper() {
      return RatebookHelper
    },
    currentProduct() {
      let currentProduct = {};

      if ( this.adminPortalData?.content?.products) {
        currentProduct = this.adminPortalData.content.products[this.route.params.scheme][0];
      }

      return currentProduct;
    },
    costTotalLabel() {
      return this.adminPortalData.content.products[this.route.params.scheme][0]?.configure_cost_total_label ? this.adminPortalData.content.products[this.route.params.scheme][0].configure_cost_total_label : '';
    },

    showModal() {
      return this.modalShow === true && this.shortlist && this.shortlist.manufacturerName.toLowerCase() === 'bmw';
    },

    showBik() {
      if (this.route.params.scheme === 'bch') {
        const productData = this.adminPortalData.content.products[this.route.params.scheme][0];
        return !productData.display_settings_show_vehicle_rental;
      }
      return false;
    },

    options: function () {
      return [this.optionalExtras[0], this.standardSpecification[0]]
    },

    totalNetCost() {
      const quote = this.shortlist.quote;
      return Number(quote.details.lifeCosts.totalEffectiveRental ?? quote.details.pricing.totalIncVAT).toFixed(2);
    },

    footerText() {
      return this.adminPortalData.content?.products?.ecoamaps
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description_required
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_requirement_and_content_fca_description
      && this.adminPortalData.content?.products?.ecoamaps[0]?.fca_description_required_on_compliance_configure
        ? this.adminPortalData.content.products.ecoamaps[0].fca_requirement_and_content_fca_description
        : false;
    },

    isBch() {
      return (this.shortlist.name === 'bch');
    },

    isSalSac() {
      return (this.shortlist.name === 'salsac');
    },

    costConfiguration() {
      return {
        showRental: this.productData?.display_settings_show_vehicle_rental ? this.productData.display_settings_vehicle_rental_type : false,
      }
    },
    productData() {
      return this.adminPortalData.content.products?.['bch']?.[0];
    },

  },

  watch: {
    vueColour: {
      deep: true,
      handler(value) {
        this.currentConfiguredQuote.color = value;
      }
    },

    vueTrim: {
      deep: true,
      handler(value) {
        this.currentConfiguredQuote.trim = value;
      }
    },

    quoteFactoryOptions: {
      deep: true,
      handler(value) {
        this.currentConfiguredQuote.options = value;
      }
    },

    currentConfiguredQuote: {
      deep: true,
      handler(value) {
        this.emitQuoteEvent();
        this.$parent.currentConfiguredQuote = value;
      }
    },

    saveConfiguration: function (properties) {
      if (properties.status) {
        this.saveQuote();
      }
    },
  },

  methods: {
    emitQuoteEvent() {
      EventBus.$emit('updateConfiguredQuote', this.currentConfiguredQuote);
    },

    setFormData() {
      this.setMileages();
      this.setTerms();
    },

    setMileages() {
      const supportMileages = [];
      const min = parseInt(this.currentProduct.contract_parameters_mileage_minimum);
      const max = parseInt(this.currentProduct.contract_parameters_mileage_maximum);
      const step = parseInt(this.currentProduct.contract_parameters_mileage_step)

      for (let i = min; i <= max; i = i + step) {
        supportMileages.push(i);
      }

      this.supportedMileages = supportMileages;
    },

    setTerms() {
      const supportTerms = [];
      const min = parseInt(this.currentProduct.contract_parameters_term_minimum);
      const max = parseInt(this.currentProduct.contract_parameters_term_maximum);
      const step = parseInt(this.currentProduct.contract_parameters_term_step)

      for (let i = min; i <= max; i = i + step) {
        supportTerms.push(i);
      }

      this.supportedTerms = supportTerms;
    },

    closeModal() {
      this.modalShow = false;
    },

    getMonthlyCost(value) {
      return (Number(value) / this.shortlist.term).toFixed(2);
    },

    tabs(tab) {
      this.tab = tab;
    },

    // Get a single shortlist item with the quote.
    get(shortListId, quoteId) {
      EventBus.$emit('loadingTitle', 'Fetching configuration options');
      EventBus.$emit('loading', true);
      this.$http.get(`/api/configure-vehicle/shortlist/${shortListId}/quote/${quoteId}`)
        .then(async response => {
          EventBus.$emit('loading', false);
          await EventBus.$emit('fetchData', ['driverprofile', 'drivergrades']);
          this.quoteFactoryOptions = response.data.data.quoteFactoryOptions;
          this.shortlist = response.data.data.shortlist;
          // Derivative is wiped when you select an option because we pull in an updated quote, so set this separately to re-set it later
          this.derivative = response.data.data.shortlist.quote.derivative;
          this.shortlistId = shortListId;
          this.derivativeFactoryOptions = response.data.data.derivativeFactoryOptions;
          this.colourOptions = response.data.data.colourOptions;
          this.trimOptions = response.data.data.trimOptions;
          this.vueColour = collect(response.data.data.colourOptions).where('selected', true).first();
          this.vueTrim = collect(response.data.data.trimOptions).where('selected', true).first();
          this.term = response.data.data.shortlist.term;

          if (this.shortlist.name === 'salsac') {
            this.mileage = response.data.data.shortlist.quote.definition.plan.annualDistance.toLocaleString();
          } else {
            this.mileage = response.data.data.shortlist.annualDistance;
          }
          this.setFormData();
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.message
          });
          this.error = err.message.toString();
          this.$router.push({name: response.redirect, params: {...this.$route.params}});
        });
    },

    // Change options from the drop-downs.
    switchTerm(value) {
      EventBus.$emit('loadingTitle', 'Updating quote');
      EventBus.$emit('loading', true);

      this.$http.post('/api/switch-term/' + this.shortlist.quote.quoteGUID, {
        shortlistId: this.shortlistId,
        term: value,
        scheme: this.shortlist.name,
      }).then(response => {
        EventBus.$emit('loading', false);

        this.$nextTick(() => {
          this.term = response.data.data.definition.plan.term;
        });
      })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.data.message ?? err.message.toString()
          });
          this.error = err.message.toString();
          this.$router.push({name: response.redirect, params: {...this.$route.params}});
        });
    },

    // Change options from the drop-downs.
    switchMileage(value) {
      EventBus.$emit('loadingTitle', 'Updating quote');
      EventBus.$emit('loading', true);

      this.$http.post('/api/switch-annual-distance/' + this.shortlist.quote.quoteGUID, {
        shortlistId: this.shortlistId,
        annualDistance: value,
        scheme: this.shortlist.name,
      }).then(response => {
        EventBus.$emit('loading', false);

        this.$nextTick(() => {
          this.mileage = response.data.data.definition.plan.annualDistance;
        });
      })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.data.message ?? err.message.toString()
          });
          this.error = err.message.toString();
          this.$router.push({name: response.redirect, params: {...this.$route.params}});
        });
    },

    // Change factory options from the drop-downs.
    changeFactoryOption(event) {
      if (event?.value) {
        this.toggleFactoryOption(this.shortlist.quote.quoteGUID, event.value, 'added')
      }
    },

    // Update a factory option on the quote.
    toggleFactoryOption(quoteGuid, factoryOptionID, operation) {
      EventBus.$emit('loadingTitle', 'Updating Quote');
      EventBus.$emit('loading', true);

      this.$http.put('/api/toggle-factory-option', {
        quoteGuid: quoteGuid,
        derivativeId: this.shortlist.derivativeID,
        factoryOptionId: factoryOptionID,
        operation: operation // added, deleted
      })
        .then(response => {
          EventBus.$emit('loading', false);

          this.$nextTick(() => {
            this.quoteFactoryOptions = response.data.data.quoteFactoryOptions;
            this.shortlist.quote = response.data.data.quote;
            this.shortlist.quote.derivative = this.derivative;
            this.derivativeFactoryOptions = response.data.data.derivativeFactoryOptions;

            this.colourOptions = response.data.data.colourOptions;
            this.vueColour = collect(response.data.data.colourOptions).where('selected', true).first();

            this.trimOptions = response.data.data.trimOptions;
            this.vueTrim = collect(response.data.data.trimOptions).where('selected', true).first();

          });

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: response.data.message
          });

        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.error.message
          });

          this.error = err.message.toString();
          if (response.redirect) {
            this.$router.push({name: response.redirect, params: {...this.$route.params}});
          }
        });
    },

    // Save the temporary quote back to the shortlist.
    // This is the re-calculate total monthly net cost button on the UI.
    // We also pass in the quote id so that we can remove the old quote
    // from the system.
    saveQuote() {

      if (!this.vueColour.value) {
        EventBus.$emit('showError', true);
        EventBus.$emit('errorTitle', 'Please select a paintwork option');
        this.$emit('saveConfiguration', {status: false});
        return false;
      }
      if (!this.vueTrim.value) {
        EventBus.$emit('showError', true);
        EventBus.$emit('errorTitle', 'Please select a trim option');
        this.$emit('saveConfiguration', {status: false});
        return false;
      }


      EventBus.$emit('loadingTitle', 'Saving Quote');
      EventBus.$emit('loading', true);
      this.$http.post('/api/configure-vehicle/shortlist', {
        quoteGuid: this.shortlist.quote.quoteGUID,
        shortlistId: this.shortlistId,
        scheme: this.shortlist.name,
      })
        .then(response => {
          EventBus.$emit('loading', false);
          this.$emit('saveConfiguration', {status: false});
          this.$parent.saveVehicleConfiguration = {};

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: response.data.message
          });

          if (response.data.redirect) {
            this.$router.push({name: response.data.redirect, params: {...this.$route.params}});
          }
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          this.$emit('saveConfiguration', {status: false});
          this.$parent.saveVehicleConfiguration = {};

          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.message
          });
          this.error = err.message.toString();
          if (response.redirect) {
            this.$router.push({name: response.redirect, params: {...this.$route.params}});
          }
        });
    },

    // The back to shortlist method simply deletes the current working 'draft'
    // quote and then routes back to the shortlists.
    backToShortlist() {
      EventBus.$emit('loadingTitle', 'Loading Shortlists');
      EventBus.$emit('loading', true);
      this.$http.post('/api/quotation', {
        method: 'DELETE',
        endpoint: `quotecalculator/${this.shortlist.quote.quoteGUID}`,
      }).then(response => {
        EventBus.$emit('loading', false);
        this.$router.push({name: 'Car Comparison'});
      });
    },

    // Deleting a quote requires that we remove the temporary quote
    // and hiding the quote from the shortlist (as we can't physically delete it using the API)
    deleteQuote() {
      this.$parent.loading = true;
      this.$http.post('/api/configure-vehicle/shortlist/quote/delete', {
        quoteId: this.quoteId,
        shortlistId: this.shortlistId,
        quoteGuid: this.shortlist.quote.quoteGUID
      })
        .then(response => {
          EventBus.$emit('loading', false);

          this.$notify({
            group: 'notify',
            type: 'success',
            title: 'Success',
            text: response.data.message
          });

          if (response.data.redirect) {
            this.$router.push({name: response.data.redirect, params: {...this.$route.params}});
          }
        })
        .catch(err => {
          EventBus.$emit('loading', false);
          let response = err.response.data;

          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.message
          });
          this.error = err.message.toString();
          if (response.redirect) {
            this.$router.push({name: response.redirect, params: {...this.$route.params}});
          }
        });
    },

    // Slick
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },

    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      // console.debug('Slick: handleAfterChange', event, slick, currentSlide);
    },

    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      // console.debug('Slick: handleBeforeChange', event, slick, currentSlide, nextSlide);
    },

    handleBreakpoint(event, slick, breakpoint) {
      // console.debug('Slick: handleBreakpoint', event, slick, breakpoint);
    },

    handleDestroy(event, slick) {
      // console.debug('Slick: handleDestroy', event, slick);
    },

    handleEdge(event, slick, direction) {
      // console.debug('Slick: handleEdge', event, slick, direction);
    },

    handleInit(event, slick) {
      // console.debug('Slick: handleInit', event, slick);
    },

    handleReInit(event, slick) {
      // console.debug('Slick: handleReInit', event, slick);
    },

    handleSetPosition(event, slick) {
      // console.debug('Slick: handleSetPosition', event, slick);
    },

    handleSwipe(event, slick, direction) {
      // console.debug('Slick: handleSwipe', event, slick, direction);
    },

    handleLazyLoaded(event, slick, image, imageSource) {
      // console.debug('Slick: handleLazyLoaded', event, slick, image, imageSource);
    },

    handleLazeLoadError(event, slick, image, imageSource) {
      // console.debug('Slick: handleLazeLoadError', event, slick, image, imageSource);
    },

    getBikRate(shortlistItem) {
      return this.session?.driverProfile?.incomeTaxBand?.ratePercent ?? 0;
    },

    getBikValue(shortlistItem) {
      return this.getBikRate && shortlistItem.quote ? Number(this.getVehicleBikByRate(shortlistItem.quote.details, this.session.driverProfile.incomeTaxBand.ratePercent)).toFixed(2) : false;

      /*if (shortlistItem.quote && (this.session.driverProfile.incomeTaxBand.ratePercent == shortlistItem.quote.details.biK1Rate)) {
          return shortlistItem.quote.details.biK1;
      }

      if (shortlistItem.quote && (this.session.driverProfile.incomeTaxBand.ratePercent == shortlistItem.quote.details.biK2Rate)) {
          return shortlistItem.quote.details.biK2;
      }

      if (shortlistItem.quote && (this.session.driverProfile.incomeTaxBand.ratePercent == shortlistItem.quote.details.biK3Rate)) {
          return shortlistItem.quote.details.biK3;
      }

      if (shortlistItem.quote && (this.session.driverProfile.incomeTaxBand.ratePercent == shortlistItem.quote.details.biK4Rate)) {
          return shortlistItem.quote.details.biK4;
      }
      return false;*/
    },

  },

  components: {
    VehicleImage,
    FooterText,
    MpgSlider,
    Slick,
    Multiselect
  },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
